import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationFactsDto } from 'src/app/application/case/dto/application-facts.dto';

import * as theGlobals from '../shared/globals';
import { IAppraiser } from '../shared/classes/appraiser';


@Injectable()

export class DictionaryService {
    private myUrl = theGlobals.setEnv().funcUrl;

    theLists = {
        cityChoices: [],
        statusChoices: [],
        subStatusChoices: [],
        propertyTypes: [],
        documentTypes: [],
        applicantTypes: [],
        securedTypes: [],
        paymentStatusTypes: [],
        assessTypes: [],
        rollYearChoices: [],
    };
    backlogYear = theGlobals.backLogYear;

    constructor(private http: HttpClient) { }

    // at this point, dictionary values are hardcoded; in future, get them from an API call - rod 3/24/2020
    getDictionaries(): any {
        this.theLists.cityChoices = ['Carpinteria', 'Casmalia', 'Cuyama', 'Gaviota', 'Goleta', 'Guadalupe', 'Lompoc', 'Los Alamos', 'Los Olivos', 'Montecito', 'Orcutt', 'Santa Barbara', 'Santa Maria', 'Santa Ynez', 'Solvang', 'Summerland', 'Vandenberg AFB'];
        // this.theLists.cityChoices = ['Albion', 'Boonville', 'Branscomb', 'Calpella', 'Casper', 'Comptche', 'Covelo', 'Dos Rios', 'Elk', 'Fort Bragg', 'Gualala', 'Hopland', 'Laytonville', 'Legge,', 'Little River', 'Manchester', 'Mendocino', 'Navarro', 'Philo', 'Piercy', 'Point Arena', 'Potter Valley', 'Redwood Valley', 'Talmage', 'Ukiah', 'Westport', 'Willits', 'Yorkville', 'Cummings', 'Longvale', 'Inglenook', 'Ancher Bay', 'Noyo', 'Cleone'];
        this.theLists.statusChoices = ['AAB Determined Value', 'Continued Hearing', 'Continued Hearing on Insufficiency', 'Continued Hearing on Late Filing', 'Continued Res Status Conference', 'Continued Status Conference', 'Denied - Insufficient', 'Denied - Late Filing', 'Denied - No Show', 'Insufficient Application Received', 'Late Application Received', 'Noticed for Hearing', 'Noticed for Hearing on Late Filing', 'Noticed for Initial Case Management Conference', 'Noticed for Insufficiency Hearing', 'Noticed for Res Status Conference', 'Noticed for Reset Hearing', 'Noticed for Status Conference', 'Ready for Hearing', 'Ready for Initial Case Management Conference', 'Ready for Res Status Conference', 'Ready for Reset Hearing', 'Ready for Status Conference', 'Scheduled for Hearing', 'Scheduled for Hearing on Late Filing', 'Scheduled for Initial Case Management Conference', 'Scheduled for Insufficiency Hearing', 'Scheduled for Res Status Conference', 'Scheduled for Reset Hearing', 'Scheduled for Status Conference', 'Stipulation Approved', 'Under Advisement', 'Waiver Denied', 'Waiver Granted', 'Withdrawal Approved'];
        this.theLists.subStatusChoices = ['Continuance Requested', 'Insufficiency Letter Sent', 'Postponement Approved', 'Postponement Requested', 'Stipulation Pending', 'Stipulation Received', 'Sufficient per AAB', 'Waiver Requested', 'Withdrawal Pending', 'Withdrawal Received'];
        this.theLists.propertyTypes = ['Single Fam Res/Condo/Townhouse', 'Apartments 2-4', 'Apartments 5+', 'Apartments (Units not Specified)', 'Commercial/Industrial', 'Bus Personal Ppty/Fixtures Only', 'Agricultural', 'Manufactured Home', 'Water Craft', 'Other', 'Possessory Interest', 'Vacant Land', 'Aircraft'];
        this.theLists.applicantTypes = ['Owner', 'Agent', 'Attorney', 'Spouse', 'Registered Domestic Partner', 'Child', 'Parent', 'Person Affected', 'Corporate Officer or Designated Employee'];
        this.theLists.securedTypes = ['Not Known', 'Secured', 'Unsecured'];
        this.theLists.assessTypes = ['Regular', 'Supplemental', 'Roll Change', 'Escape', 'Calamity', 'Penalty'];   // THIS IS NOT THE COMPLETE LIST!
        // original Document Types
        // this.theLists.documentTypes = ['Application', 'Appraisal', 'Agent Authorization Form', 'Continuation Request', 'Hearing Date Confirmation Notice', 'Other', 'Stipulation', 'Supplemental', 'Waiver', 'Withdrawal'];
        // new version, combining EFile docs and Management App docs
        this.theLists.documentTypes = [
            { id: 0, name: 'Application' },
            { id: 6, name: 'Appraisal' },
            { id: 1, name: 'Agent Authorization Form' },
            { id: 7, name: 'Continuation Request' },
            { id: 8, name: 'Hearing Date Confirmation Notice' },
            { id: 5, name: 'Other' },
            { id: 4, name: 'Other Explanation' },
            { id: 3, name: 'Personal Property Description' },
            { id: 13, name: 'Postponement Request' },
            { id: 9, name: 'Stipulation' },
            { id: 10, name: 'Supplemental' },
            { id: 2, name: 'Tax Notice' },
            { id: 11, name: 'Waiver' },
            { id: 12, name: 'Withdrawal' },
        ];

        /* Pending = 1,  InProgress = 2,  Completed = 3,  Error = 4, Failed = 5, Cancelled = 6 */
        this.theLists.paymentStatusTypes = [
            { id: 1, description: 'Pending' },
            { id: 2, description: 'InProgress' },
            { id: 3, description: 'Completed' },
            { id: 4, description: 'Error' },
            { id: 5, description: 'Failed' },
            { id: 6, description: 'Cancelled'},
        ];
        // Roll Years available for filing (default going back 10 years)
        this.theLists.rollYearChoices = [];
        const curYear = new Date().getFullYear();
        const backlogYear = this.backlogYear;   // how many years to go back
        const firstYear = curYear - backlogYear;
        for (let yr = curYear; yr > firstYear; yr--) {
            const rollYr = {
                value: (yr - 1).toString(),
                desc: yr.toString() + '/' + (yr + 1).toString()
            };
            this.theLists.rollYearChoices.push(rollYr);
        }
        return this.theLists;
    }

    // get list of available FACTS
    getFactsList(): Observable<ApplicationFactsDto[]> {
        const xUrl = this.myUrl + '/facts';
        return this.http.get<any>(xUrl);
    }

    // get list of "assignable" Appraisers/Assessors, i.e. of non-ReadOnly type
    // object = { id: number, name: string, isActive: bool, appealsUserId: number }
    getAssessorList(): Observable<any[]> {
        const xUrl = this.myUrl + '/appraisers/only';
        return this.http.get<any[]>(xUrl);
    }

    saveAssessor(appraiser: IAppraiser): Observable<any> {
      let xUrl = this.myUrl + '/appraiser';
      if (appraiser.id === 0) {
        return this.http.post(xUrl, appraiser);
      } else {
        xUrl = xUrl + '/' + appraiser.id;
        return this.http.put(xUrl, appraiser);
      }
    }

    deleteAssessor(appraiser: IAppraiser): Observable<any> {
      const xUrl = this.myUrl + '/appraiser';
      return this.http.delete(xUrl + '/' + appraiser.id);
    }

    // get ASSESSOR-related dictionary; used in Assessor section of Case, Case Listing report, etc.
    // types:  crew, division, specialcase,  usecode
    getCaseDictionaries(dictType: string): Observable<any> {
        const xUrl = this.myUrl + '/dict/' + dictType;
        return this.http.get<any[]>(xUrl);
    }
  // get UseCode translation
  getUseCodeTrans(useCode: string): Observable<any> {
    const xUrl = this.myUrl + '/dict/usecode/' + useCode;
    return this.http.get(xUrl);
  }

    // save various types of dictionaries: crew, division, specialcase
    saveCaseDictionaries(dictType: string, item: any): Observable<any> {
      // types:  crew, division, specialcase
      const xUrl = this.myUrl + '/dict/' + dictType;
      if (item.id === 0) {
        return this.http.post(xUrl, item);
      } else {
        return this.http.put(xUrl + '/' + item.id, item);
      }

    }
    // DELETE various types of dictionaries: crew, division, specialcase,  usecode
    deleteCaseDictionaries(dictType: string, id: string): Observable<any> {
    const xUrl = this.myUrl + '/dict/' + dictType + '/' + id;
    return this.http.delete<any>(xUrl);
  }
  getSystemConstants(): Observable<any[]> {
    const xUrl = this.myUrl + '/dict/sysconst';
    return this.http.get<any[]>(xUrl);
  }
  saveSystemConstant(constType: string, item: any): Observable<any> {
    const xUrl = this.myUrl + '/dict/sysconst/' + constType;
      return this.http.put(xUrl, item);
  }
}
